import UserInfo from "../UserInfo";
import { TranslateW } from "./Languages/Translate";

export const renderLbs = (weightValue, weightPrecision = 3) => `${parseFloat(Number(weightValue).toFixed(weightPrecision))} ${TranslateW('LbsUnit')}.`;

export const renderKgs = (weightValue, weightPrecision = 2) => {
    const kg = 0.453592;
    const lbsToKg = (weightValue * kg).toFixed(weightPrecision);
    return `${lbsToKg} kgs.`;
};

const badValues = [undefined, null, ""];

export const renderWeight = (weightValue, lbsWeightPrecision = 3, kgsWeightPrecision = 2 ) => {
    if (isNaN(weightValue) || badValues.includes(weightValue)) return 'N/A';
    const usersWeightUnits = UserInfo.getWeightUnits();
    return usersWeightUnits === 'Lbs' ? renderLbs(weightValue, lbsWeightPrecision) : renderKgs(weightValue, kgsWeightPrecision);
};